import { Component } from '@angular/core';
import { SharedService } from '../../_services/shared.service';

import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'app-offer-declined',
    standalone: true,
    imports: [MatCardModule],
    templateUrl: './offer-declined.component.html',
    styleUrl: './offer-declined.component.scss'
})
export class OfferDeclinedComponent {


  constructor(public sharedService: SharedService){

  }

}
